onReady(($) => {
    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (!entry.isIntersecting) {
                return;
            }

            const statCounter = entry.target;
            const convertedNumber = +statCounter.dataset.target;
            if (!convertedNumber) {
                return;
            }

            let animationStartTime = 0;
            const replaceString = statCounter.textContent.replace(/\d+/, '')
            const animationCount = time => {
                if (!animationStartTime) {
                    animationStartTime = time;
                }
                const animationTime = (time - animationStartTime) / 2000;
                statCounter.textContent = Math.floor(animationTime * convertedNumber) + replaceString;
                if (animationTime < 1) {
                    requestAnimationFrame(animationCount);
                }
                else {
                    statCounter.textContent = convertedNumber + replaceString;
                }
            };

            requestAnimationFrame(animationCount);
            observer.unobserve(statCounter);
        });
    });

    document.querySelectorAll('.statistic.module .counter')
        .forEach(statCounter => {
            observer.observe(statCounter);
        });
});
